var currencyFormatter = function (currency) {
    return new Intl.NumberFormat(undefined, {
        currency: currency,
        currencyDisplay: 'narrowSymbol',
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
        roundingMode: 'floor',
        style: 'currency',
    });
};
export var currencyFormat = function (amount, currency) {
    // undefined uses the runtimes default locale
    return new Intl.NumberFormat(undefined, {
        currency: currency,
        currencyDisplay: 'narrowSymbol',
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
        roundingMode: 'floor',
        style: 'currency',
    }).format(amount);
};
export default currencyFormatter;
